'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RichEditor = require('../RichEditor/RichEditor');

var _RichEditor2 = _interopRequireDefault(_RichEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dashboard = function (_Component) {
  (0, _inherits3.default)(Dashboard, _Component);

  function Dashboard() {
    (0, _classCallCheck3.default)(this, Dashboard);
    return (0, _possibleConstructorReturn3.default)(this, (Dashboard.__proto__ || (0, _getPrototypeOf2.default)(Dashboard)).apply(this, arguments));
  }

  (0, _createClass3.default)(Dashboard, [{
    key: 'render',
    value: function render() {
      var styles = require('./Dashboard.scss');
      // require the logo image both from client and server
      return _react2.default.createElement(
        'div',
        { className: styles.newDocument },
        _react2.default.createElement('div', { className: styles.newDocumentToolbar }),
        _react2.default.createElement(
          'div',
          { className: styles.exercisesList },
          _react2.default.createElement(
            'div',
            { className: styles.exercicesListItem },
            'Exercice 1'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.exercicesListItem },
            'Exercice 2'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.exercicesListItem },
            'Exercice 3'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.content },
          _react2.default.createElement(
            'section',
            { className: styles.box },
            _react2.default.createElement(
              'h1',
              null,
              'Exercice 1'
            ),
            _react2.default.createElement(_RichEditor2.default, { key: '1', placeholder: 'Ent\xEAte de l\'exercice' }),
            _react2.default.createElement(_RichEditor2.default, { key: '2', placeholder: 'Ent\xEAte de la question 1' }),
            _react2.default.createElement(_RichEditor2.default, { key: '3', placeholder: 'Question 1' }),
            _react2.default.createElement(_RichEditor2.default, { key: '4', placeholder: 'Corrig\xE9 de la question 1' })
          )
        )
      );
    }
  }]);
  return Dashboard;
}(_react.Component);

exports.default = Dashboard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Dashboard/Dashboard.js
// module id = 1185
// module chunks = 0